import React, { useState, useEffect } from 'react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import EventCard from '../../components/public/EventCard';
import api from '../../utils/api';
import '../../components/public/Public.css';

export default function Home() {
  const [events, setEvents]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');

  useEffect(() => {
    let active = true;
    api.get('/public/events')
      .then(r => { if (active) setEvents(Array.isArray(r.data) ? r.data : []); })
      .catch(() => {})
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const filtered = events.filter(e =>
    filter === 'free' ? e.is_free : filter === 'paid' ? !e.is_free : true
  );

  return (
    <div className="pub-page">
      <Navbar />

      <section className="pub-hero">
        <div className="pub-container pub-hero-inner">
          <span className="pub-hero-badge">✨ {events.length} event{events.length !== 1 ? 's' : ''} open for registration</span>
          <h1>Where great <em>experiences</em> begin.</h1>
          <p>Browse upcoming workshops, conferences, and meetups — then reserve your spot in under a minute. Free and paid events, beautifully simple.</p>
          <div className="pub-hero-actions">
            <a href="#events" className="pub-btn pub-btn-accent">Explore Events</a>
            <a href="#features" className="pub-btn pub-btn-ghost">How it works</a>
          </div>
          <div className="pub-hero-stats">
            <div className="pub-hero-stat"><div className="n">{events.length}</div><div className="l">Live events</div></div>
            <div className="pub-hero-stat"><div className="n">{events.filter(e => e.is_free).length}</div><div className="l">Free to join</div></div>
            <div className="pub-hero-stat"><div className="n">1 min</div><div className="l">To register</div></div>
          </div>
        </div>
      </section>

      <section className="pub-section" id="events">
        <div className="pub-container">
          <div className="pub-section-head">
            <div>
              <h2>Upcoming events</h2>
              <p>Find your next experience from our curated lineup.</p>
            </div>
            <div className="pub-filters">
              {[['all', 'All'], ['free', 'Free'], ['paid', 'Paid']].map(([k, l]) => (
                <button key={k} className={`pub-filter ${filter === k ? 'active' : ''}`} onClick={() => setFilter(k)}>{l}</button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="pub-loading"><div className="pub-spinner" /></div>
          ) : filtered.length === 0 ? (
            <div className="pub-empty">
              <div className="pub-empty-ic">🗓️</div>
              <h3>No events yet</h3>
              <p>{filter === 'all' ? 'Check back soon — new events are added regularly.' : `No ${filter} events right now.`}</p>
            </div>
          ) : (
            <div className="pub-events-grid">
              {filtered.map(ev => <EventCard key={ev.id} event={ev} />)}
            </div>
          )}
        </div>
      </section>

      <section className="pub-features" id="features">
        <div className="pub-container">
          <div className="pub-features-grid">
            <div className="pub-feature">
              <div className="pub-feature-ic">⚡</div>
              <h3>Register in seconds</h3>
              <p>Returning guests are recognised instantly — no forms to fill again. New guests verify once and they're in.</p>
            </div>
            <div className="pub-feature">
              <div className="pub-feature-ic">🔒</div>
              <h3>Pay your way</h3>
              <p>Mobile Money, bank transfer, or card. Secure checkout with instant confirmation when it clears.</p>
            </div>
            <div className="pub-feature">
              <div className="pub-feature-ic">📩</div>
              <h3>Instant confirmation</h3>
              <p>Get an email and SMS the moment your spot is secured, with all the event details you need.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="pub-cta-band">
        <div className="pub-container">
          <div className="pub-cta-inner">
            <h2>Ready to find your next event?</h2>
            <p>Join thousands of attendees discovering experiences they love.</p>
            <a href="#events" className="pub-btn pub-btn-light">Browse all events</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
